import React from 'react';
import { motion } from 'framer-motion';

const CTA = () => {
  return (
    <section className="py-24 bg-lightbg relative overflow-hidden">
      <div className="absolute inset-0 bg-primary/5"></div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="glass-card p-10 md:p-16 text-center max-w-4xl mx-auto shadow-2xl relative overflow-hidden"
        >
          {/* Subtle inner glow */}
          <div className="absolute inset-0 bg-gradient-to-t from-emerald-50/50 to-transparent pointer-events-none"></div>

          <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-6 relative z-10 tracking-tight">
            Ready to Build a <span className="premium-gradient-text">Sustainable</span> Future?
          </h2>
          <p className="text-xl text-slate-600 mb-10 max-w-2xl mx-auto relative z-10">
            Every action toward sustainability creates lasting impact. By choosing climate responsibility today, your business becomes a leader of a greener tomorrow.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-5 relative z-10">
            <button className="btn-premium weightless-btn flex items-center justify-center">
              Partner With Us
            </button>
            <button className="bg-white hover:bg-slate-50 text-slate-800 border-2 border-slate-200 hover:border-slate-300 px-8 py-4 rounded-full font-bold text-lg transition-all shadow-sm weightless-btn">
              Request Assessment
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
